import React, { FC } from 'react';
import { useEffect, useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { api } from 'services/api';
import { Location } from 'types/location';
import { initialLocation, initialMeta } from 'services/initialStates';
import { LocationMainPage } from 'client/pages/Main/LocationMainPage';
import { Meta } from 'types/meta';
import { Loading } from 'common/components/Loading';
import { LoadingError } from 'common/components/LoadingError';
import { useTranslation } from 'react-i18next';
import { QrType } from 'types/qrType';
import { FullScreen } from 'styles/FullScreen';
import { MenuPage } from 'client/pages/MenuPage';
import { FormPage } from 'client/pages/Form/FormPage';
import { BackgroundImage } from 'styles/BackgroundImage';
import { ActionSentPage } from 'client/pages/ActionSentPage';

export const LocationDispatcher: FC<{ qrType: QrType }> = ({ qrType }) => {
  const { hash } = useParams() as { hash: string };
  const [meta, setMeta] = useState<Meta>(initialMeta);
  const [location, setLocation] = useState<Location>(initialLocation);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    retrieveLocation();
  }, []);

  const retrieveLocation = () => {
    api()
      .getLocation(hash, qrType)
      .then(response => {
        if (response.error) setLoadingError(true);
        else {
          setLocation(response.data);
          setMeta(response.meta);
          setLoading(false);
        }
      });
  };
  if (loading) return <Loading />;
  if (loadingError)
    return <LoadingError error={t('failedToRetrieveCompanyData')} />;
  return (
    <FullScreen>
      <BackgroundImage source={meta.background} />
      <Routes>
        <Route
          path="/"
          element={
            <LocationMainPage
              location={location}
              meta={meta}
              qrType={qrType}
              hash={hash}
            />
          }
        />
        <Route
          path="feedback"
          element={
            <FormPage
              entity={location}
              meta={meta}
              qrType={qrType}
              preview={false}
            />
          }
        />
        <Route
          path="menu/:id"
          element={
            <MenuPage
              entity={location}
              company={location.company}
              meta={meta}
            />
          }
        />
        <Route path="/launch_action" element={<ActionSentPage meta={meta} />} />
      </Routes>
    </FullScreen>
  );
};
